/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import {
  SettingOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import UnidadesResponsables from 'views/Configuracion/UnidadesResponsables';
import * as Usuarios from 'views/Configuracion/Usuarios';
import Entidad, { permissionEntidad } from 'views/Configuracion/EntidadMunicipal/index';
import * as Roles from 'views/Configuracion/Roles';
import CuentasBancarias from 'views/Configuracion/CuentasBancarias';
import * as CuentaDeUsuario from 'views/Configuracion/CuentaDeUsuario';
import Facturacion from 'views/Configuracion/Facturacion/Facturacion';
import TerminalDeNetPay from 'views/Configuracion/TerminalDeNetPay';
import ClasificadoresDeTiposDeCargos from 'views/Configuracion/ClasificadoresDeTiposDeCargos';
import Factibilidad from 'views/Configuracion/Factibilidad';
import EstadoDeTramites from 'views/Configuracion/EstadosDeTramites';

export default {
  title: 'Configuración',
  icon: () => <SettingOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Entidad',
      icon: () => <HomeOutlined />,
      showInSidebar: true,
      type: 'private',
      component: Entidad,
      ...permissionEntidad,
    },
    // {
    //   title: 'Clases de Declaraciones Empresariales',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: ClasesDeDeclaracionesEmpresariales,
    //   permissionModel: 'clasededeclaracionempresarial',
    // },
    {
      title: 'Usuarios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Usuarios.default,
      permissionConfig: Usuarios.permissionConfig,
    },
    {
      title: 'Dependencias',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: UnidadesResponsables,
      permissionModel: 'unidadoperativa',
    },
    {
      title: 'Departamentos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: UnidadesResponsables,
      permissionModel: 'unidadresponsable',
    },
    // {
    //   title: 'CAAR',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: UnidadesResponsables,
    //   permissionModel: 'unidadresponsable',
    // },
    {
      title: 'Roles',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Roles.default,
      permissionConfig: Roles.permissionConfig,
    },
    {
      title: 'Clasificaciones de Tipos de Cargos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: ClasificadoresDeTiposDeCargos,
      permissionModel: 'clasificadordetipodecargoenportal',
      // catalogsModels: ['permission'],
    },
    // {
    //   title: 'Puestos',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Puestos,
    //   permissionModel: 'puesto',
    // },
    {
      title: 'Cuenta de Usuario',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CuentaDeUsuario.default,
      permissionConfig: CuentaDeUsuario.permissionConfig,
    },
    // {
    //   title: 'Horarios de Trabajo',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Horarios,
    //   permissionModel: 'horario',
    // },
    // {
    //   title: 'Dias Inhabiles',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: DiasInhabiles,
    //   permissionModel: 'horario',
    // },
    // {
    //   title: 'Funcionarios',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Funcionarios,
    //   permissionModel: 'funcionario',
    //   catalogsModels: ['estadodelfuncionario', 'estadocivil', 'genero'],
    // },
    {
      title: 'CFDI y Factura',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Facturacion,
      permissionModel: 'recibo',
    },
    // {
    //   title: 'Lista de Accesos IP',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: ListaDeAccesosIP,
    //   permissionModel: 'listadeaccesoip',
    // },
    // {
    //   title: 'Zonas Horarias',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Blank,
    //   permissionModel: '',
    // },
    // {
    //   title: 'Justificaciones',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Justificaciones,
    //   permissionModel: 'justificaciondeusuarioexterno',
    // },
    // {
    //   title: 'Funciones',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Funcion,
    //   permissionModel: 'funciondelusuarioexterno',
    //   catalogsModels: ['group'],
    // },
    {
      title: 'Cuentas Bancarias',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CuentasBancarias,
      permissionModel: 'cuentadebanco',
    },
    {
      title: 'Terminales de NetPay',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TerminalDeNetPay,
      permissionModel: 'terminaldenetpay',
    },
    {
      title: 'Factibilidad',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Factibilidad,
      permissionModel: 'factibilidad',
    },
    {
      title: 'Estados de los tramites',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: EstadoDeTramites,
      permissionModel: 'catalogodelestadodeltramite',
    },
  ],
};
